function validateUser(form){
    let errors = {}
    errors.email = !form.email;
    errors.user_full_name = !form.user_full_name;
    errors.tier = !form.tier;
    return errors;
}


export {validateUser};